import http, { HttpSuccessOrErrorType } from '../http';
import qs from 'qs';
import { Admin, Staff } from '../../models';
import { Reseller } from '../../models/reseller.entity';

/** 仅序列化登录所需字段并 trim，避免误传 accessToken 等与鉴权无关字段 */
const loginFormBody = (params: { phone?: string; password?: string; phone_prefix?: string }): string =>
    qs.stringify({
        phone: String(params.phone ?? '').trim(),
        password: String(params.password ?? '').trim(),
        phone_prefix: String(params.phone_prefix ?? '').trim(),
    });

const api = {
    /**
     * 登录获取token admin登录
     * @param params 参数
     */
    async post_admin_auto_token(params: Admin): Promise<HttpSuccessOrErrorType<Admin>> {
        return await http.post('/auth/admin/token',
            loginFormBody(params)
            , {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'authorization-type': 'BASIC_AUTH'
                },
            });
    },
      
    /**
     * 登录获取token reseller登录
     * @param params 参数
     */
      async post_reseller_auto_token(params: Reseller): Promise<HttpSuccessOrErrorType<Reseller>> {
        return await http.post('/auth/reseller/token',
            loginFormBody(params)
            , {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'authorization-type': 'BASIC_AUTH'
                },
            });
    },

    /**
     * 登录获取token staff登录
     * @param params 参数
     */
    async post_staff_auto_token(params: Staff): Promise<HttpSuccessOrErrorType<Staff>> {
        return await http.post('/auth/staff/token',
            loginFormBody(params)
            , {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'authorization-type': 'BASIC_AUTH'
                },
            })
    },

    /**
     * 根据token获取到个人信息
     * @param params 参数
     */
    async get_auth_token_metadata(): Promise<HttpSuccessOrErrorType<Admin>> {
        return await http.get('/auth/token/metadata',
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                    'authorization-type': 'BASIC_AUTH'
                }
            })
    }
}
export default api